import { DateTime } from 'luxon';
import { TodoDtoWithMember } from '../hooks/useFollowUpEventsData';
import { TodoTypeDto } from '@act/shared/data-transfer-objects';
import { StringHelper } from '@act/shared/utilities';

export const formattedDateTimeFromTodo = (todo: TodoDtoWithMember) => {
  let timeMillis;

  if (todo.call) {
    timeMillis = todo.call.timestamp;
  } else if (todo.feedbackCall) {
    timeMillis = todo.feedbackCall.timestamp;
  } else if (todo.message) {
    timeMillis = todo.message.timestamp;
  } else if (todo.visit) {
    timeMillis = todo.visit.timestamp;
  } else if (todo.hospitalization) {
    if (todo.hospitalization.dischargeDate) {
      timeMillis = todo.hospitalization.dischargeDate;
    } else {
      timeMillis = todo.hospitalization.admitDate;
    }
  } else {
    return { date: '––', time: '' };
  }

  if (todo.hospitalization) {
    const formatted = DateTime.fromFormat(timeMillis, 'yyyy-MM-dd').toFormat(
      'LLL dd'
    );
    return { date: formatted, time: '' };
  }

  const dateTime = DateTime.fromMillis(timeMillis);
  return {
    date: dateTime.toFormat('LLL dd'),
    time: dateTime.toFormat('h:mma'),
  };
};

const taskFormatMap: { [key in TodoTypeDto]?: string } = {
  [TodoTypeDto.INCOMPLETE_CALL]: 'Complete call',
  [TodoTypeDto.INCOMPLETE_NOTE_CALL]: 'Complete note',
  [TodoTypeDto.INCOMPLETE_NOTE_VISIT]: 'Complete note',
  [TodoTypeDto.INCOMPLETE_VISIT]: 'Complete visit',
  [TodoTypeDto.CALL_BACK]: 'Call back',
  [TodoTypeDto.TEXT_BACK]: 'Text back',
  [TodoTypeDto.HOSPITALIZATION_FOLLOW_UP]: 'Hospitalization follow up',
  [TodoTypeDto.CALL_AUDIT]: 'Review call',
};

export function formatTaskType(data: TodoDtoWithMember) {
  const taskType = data.type;

  if (taskType === TodoTypeDto.HOSPITALIZATION_FOLLOW_UP) {
    if (data.hospitalization.dischargeDate) {
      return 'Discharge follow up';
    }
    return 'Admission follow up';
  }

  return taskFormatMap[taskType] || taskType;
}

export function formatEventType(data: TodoDtoWithMember) {
  const { externalItemType: itemType } = data;

  if (itemType === 'call' || itemType === 'message') {
    return StringHelper.sentenceCase(
      `${data[itemType]?.incoming ? 'incoming' : 'outgoing'} ${itemType}`
    );
  }

  if (itemType === 'feedback_call') {
    return 'Incoming call';
  }

  return StringHelper.sentenceCase(itemType);
}
